import { createContext, useContext } from 'react';

import type { NHeaderProvider } from '@app/providers/HeaderProvider/HeaderProvider.types';

export const HeaderContext = createContext<NHeaderProvider.State>({
  header: {},
  isLoading: false,
  setHeader: () => {},
  setIsLoading: () => {},
});

export const useHeader = () => {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error('useHeader must be used within a HeaderProvider');
  }
  return context;
};
